// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
// This file can't be typed checked because all IE11 checks are ancient and not supported

function checkForIe11() {
  return (
    typeof window !== 'undefined' &&
    !!window.MSInputMethodContext &&
    !!document.documentMode
  );
}

function checkEdgeCompatibilityMode() {
  if (navigator.userAgent.indexOf('Edge/') > -1) {
    // Check if in IE mode
    if (document.documentMode) {
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }
}

export function useIsSupportedBrowser() {
  const isIE11 = checkForIe11();
  const isEdgeCompatibilityMode = checkEdgeCompatibilityMode();

  return !isIE11 && !isEdgeCompatibilityMode;
}
